import { render } from "./TaskPublish.vue?vue&type=template&id=6b1bae8e"
import script from "./TaskPublish.vue?vue&type=script&lang=js"
export * from "./TaskPublish.vue?vue&type=script&lang=js"

import "./TaskPublish.vue?vue&type=style&index=0&id=6b1bae8e&lang=less"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__